import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { DropdownLink, DropdownText, Href } from "../../../../Constants/Constants";

export const NestingButton1 = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="m-b-30">
      <ButtonGroup>
        <Btn color="primary"><i className="fa fa-bold"></i></Btn>
        <Btn color="secondary"><i className="fa fa-italic"></i></Btn>
        <ButtonGroup>
          <Dropdown isOpen={open} toggle={() => setOpen(!open)}>
            <DropdownToggle caret color="light" className="text-dark">{DropdownText}</DropdownToggle>
            <DropdownMenu>
              <DropdownItem href={Href}>{DropdownLink}</DropdownItem>
              <DropdownItem href={Href}>{DropdownLink}</DropdownItem>
              <DropdownItem href={Href}>{DropdownLink}</DropdownItem>
              <DropdownItem href={Href}>{DropdownLink}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ButtonGroup>
      </ButtonGroup>
    </div>
  );
};
